import { useContext, useState, useEffect } from 'react';

import AuthContext from '../../store/AuthContext';
import ValidatedToken from "./ValidatedToken";
import CopyButton from '../widgets/CopyButton';
import JwtIoButton from '../widgets/JwtIoButton';
import { decodeToken}  from '../../services/tokenValidator';
import * as services from '../../services/services';
import * as utils from '../../services/utils';

function AccessToken () { 
  const iuaCtx = useContext(AuthContext);

  // TODO empty
  // let tokenEmpty = 'No data found';
  let tokenEmpty = '';
  const [accessToken, setAccessToken] = useState(tokenEmpty);
  const [accessTokenErr, setAccessTokenErr] = useState('');
  const [parsedAccessToken, setParsedAccessToken] = useState({});
  const [validationResult, setValidationResult] = useState('');
  const [displayStyle, setDisplayStyle] = useState({header: 'success'});
  
  useEffect(() => {
    const transType = sessionStorage.getItem('transType');
    if (transType === utils.TRANS.auth_code) {
      // Auth Code Flow
      if (iuaCtx.authCode) { 
        getAccessToken()
          .then(() => {
            iuaCtx.setAccessToken(accessToken);
            iuaCtx.setAuthErr(accessTokenErr);
            return accessToken;
          })
          .then(accessToken => validateToken(accessToken));

        } else {
          const authErr = iuaCtx.authErr;
          authErr && setAccessTokenErr(authErr);
        }  

    } else {
      // Client Credentials Flow
      const token = iuaCtx.accessToken;
      setAccessToken(token);
      const authErr = iuaCtx.authErr;
      authErr && setAccessTokenErr(authErr);
      // TODO: error
      if (token && authErr) {
        console.error('Found both token and authorization error, this should not happen');
      }
      validateToken(token);
    }
    if (accessToken) {
      setDisplayStyle({
        header: 'success'
      });
    } else {
      setDisplayStyle({
        header: 'error'
      });     
    }
    
  }, [iuaCtx.authCode, iuaCtx.authErr, accessToken, accessTokenErr]);

  function getAccessToken() {
    if (accessToken) {
      return new Promise((resolve) => resolve('Done'));
    }

    const url = sessionStorage.getItem('tokenUri');

    const params = {
      grant_type: utils.AUTH_CODE_GRANT_TYPE,
      client_id: sessionStorage.getItem('clientId'),
      client_secret: sessionStorage.getItem('clientSecret'),
      code: iuaCtx.authCode,
      code_verifier: sessionStorage.getItem('codeVerifier'),
      redirect_uri: sessionStorage.getItem('redirectUri')
    };

    return services.getToken(url, params)
      .then(result => { 
        const token = result?.access_token;        
        if (token) {          
          setAccessToken(token);
        } else {
          const error = result?.data && utils.objectToString(result?.data);
          error && setAccessTokenErr(error);
        }         
      })
      .finally(() => {
        utils.cleanup();
      });
  }

  function validateToken(token) {
    if (!token) {
      return;
    }
    const tokenInfo = token.split('.');
    
    // verification
    if (tokenInfo.length < 3) {
      const errorMsg = 'Unable to decode access token. ' +
      'Token expected to have 3 parts separated by ".", but found only ' + tokenInfo.length
      console.error(errorMsg);
      return;
    }
    setParsedAccessToken({
      header: tokenInfo[0],
      payload: tokenInfo[1],
      signature: tokenInfo[2]
    });
    decodeToken(token)
      .then(result => {
        setValidationResult(result);
      });
  }

  const tokenDisplaySuccess = 
    <div>
      <span className="light-pink-text">{parsedAccessToken.header}</span>
      <span>.</span>
      <span className="light-purple-text">{parsedAccessToken.payload}</span>
      <span>.</span>
      <span className="light-blue-text">{parsedAccessToken.signature}</span>
    </div>

  const tokenDisplayError = 
    <div>
      <pre className="error-text">{accessTokenErr}</pre>
    </div>

  const tokenDisplay = accessToken ? tokenDisplaySuccess : tokenDisplayError;

  return (
    <div>
      <div className={"card card-body code-block " + displayStyle.header} title="Access Token">
      <div className={"main-form-output spc-pb-6"}>
          {tokenDisplay} 
          <JwtIoButton token={accessToken}></JwtIoButton>
          <CopyButton data={accessToken || accessTokenErr}></CopyButton>
        </div>
      </div>
      <ValidatedToken validationResult={validationResult}></ValidatedToken>
    </div>
  );

}

export default AccessToken;